const authority = "https://auth-candidate.erecruiter.pl";
const apiUrl = "https://api-candidate.erecruiter.pl";
const baseUrl = "https://candidateaccountweb.gpcdn.pl";

const config = {
	authorization: {
		authority: `${authority}`,
		post_logout_redirect_uri: `${authority}/Account/SendMagicLink`,
		post_account_delete_redirect_uri: `${authority}/Account/SendMagicLink?accountDeleted=true`,
	},
	urls: {
		apiRoot: `${apiUrl}/`,
		apiAuthRoot: `${authority}/`,
		publicBaseUrl: `${baseUrl}/`,
	},
	sentry: {
		dsn: "https://2ac2fc11c54149f7b6d2b2b5dbd0fdae@o404438.ingest.sentry.io/5268158",
		environment: "Production",
		release: "Release_20261009.3",
	},
};
export default config;
